import Vue from 'vue'
import axios from 'axios'
import { notify } from './notify'


const token = localStorage.getItem('token')
const url = "https://api.royalnetcyprus.com/api/"

const axiosIns = axios.create({
  baseURL: url,
  headers: {
    'Authorization': 'Bearer ' + token,
    'Accept': 'application/json'
  },
})


axiosIns.interceptors.request.use(config => {
     /* some logic */
    const controller = new AbortController();
    controller.abort();
  
  
    return {
      ...config,
      signal: controller.signal
    };
})

axiosIns.interceptors.response.use((response) => {
  return response;
}, (error) => {
  let errors = [];
  const errorStatusCode = error.response.status;
  switch (errorStatusCode) {
    case 500:
      notify.error('Veritabanı Hatası') 
    break;
    case 422:
      Object.keys(error.response.data.errors).map(_ => {
        errors.push(error.response.data.errors[_])
      })
      notify.error(errors) 
      break;
    case 401:
        notify.error('Giriş Yapmanız Gerekmektedir')
      break;
    
    default:
      break;
  }

});

Vue.prototype.$http = axiosIns


export default axiosIns
